module.exports = __webpack_public_path__ + "img/antyk_i_jasny.b381aa05.jpg";